export const settings = {
  setShareTitle: 'Compartilhar aplicativo',
  setNotifiationsTitle: 'Notificações',
  setContactAppOwnerTitle: 'Contatar proprietário do aplicativo',
  setContactDevelopersTitle: 'Contatar desenvolvedores',
  setReportAppTitle: 'Reportar aplicativo',
  setDeleteAccountTitle: 'Excluir conta',
  setLogOutTitle: 'Sair',
  setShareAppCurtainTitle: 'Compartilhar aplicativo',
  setShareAppCurtainButtonTitle: 'Copiar link',
  setShareAppAlertWhenAppLinkWasCopied: 'Link copiado!',
  setNotificationsInAppTitle: 'No aplicativo',
  setNotificationsPushContent: 'Push',
  setNotificationsChatsTitle: 'Conversas',
  setNotificationsDiscussionsTitle: 'Discussões',
  setNotificationsNewsTitle: 'Feed de notícias',
  setNotificationsEventsTitle: 'Eventos',
  setNotificationsAdminTitle: 'Mensagens do administrador',
  setNotificationsBlogTitle: 'Blog',
  setNotificationsPushOffContent: 'As notificações push estão desativadas',
  setNotificationsPushOffText: 'Para ativar as notificações, acesse as configurações do seu dispositivo e ative as notificações',
  setReportAppFlagCurtainTitle: 'Reportar',
  setAppReportedCurtainContent: 'Conteúdo reportado',
  setDeleteCurtainTitle: 'Excluir conta',
  setDeleteCurtainInputContent: 'Senha',
  setDeleteCurtainCancelButtonTitle: 'Cancelar',
  setDeleteCurtainConfirmButtonTitle: 'Confirmar',
  setDeleteCurtainIncorrectPasswordAlertText: 'Senha incorreta',
  setTurnNotificationsOnText: 'Para ativá-las, clique no botão abaixo e permita receber notificações.',
  setTurnNotificationsOnButton: 'Ativar notificações push'
}
